import FusionCharts from 'fusioncharts';
import Charts from 'fusioncharts/fusioncharts.charts';
import ReactFC from 'react-fusioncharts';
import Widgets from 'fusioncharts/fusioncharts.widgets';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import PowerCharts from 'fusioncharts/fusioncharts.powercharts';

export const initFusionCharts = async () => {
    setFusionChartsLicense();

    Charts(FusionCharts);
    ReactFC.fcRoot(FusionCharts, Charts, Widgets, PowerCharts, FusionTheme);
};

export const setFusionChartsLicense = (key?: string) => {
    FusionCharts.options['license']({
        // @ts-ignore: Unreachable code error
        key: key || import.meta.env.VITE_FCKEY,
        creditLabel: false
    });
};
